<template>
  <div v-if="show" class="overlay">
    <div class="retention-dialog">
      <div class="actions">
        <button class="btn cancel-btn" @click="onCancel">继续退出</button>
        <button class="btn confirm-btn" @click="onConfirm">联系客服</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RetentionDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  .retention-dialog {
    width: 80vw;
    height: 80vw;
    position: relative;
    background: url("../assets/servicePopup.png") no-repeat;
    background-size: contain;

    .actions {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2.667vw;
      position: absolute;
      bottom: 7.467vw;
      left: 0;

      .btn {
        margin: 0;
        width: 34.667vw;
        height: 12vw;
        border: none;
        border-radius: 6vw;
        font-size: 5.067vw;
        display: flex;
        align-items: center;
        justify-content: center;

        &.cancel-btn {
          color: #0062fd;
          border: 1px solid #0062fd;
          box-sizing: border-box;
          background-color: #fff;
        }

        &.confirm-btn {
          background: #0062fd;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
